// extracted by mini-css-extract-plugin
module.exports = {"total-price":"MiddleBorder_total-price__UUsLa"};